module.exports = __webpack_public_path__ + "static/media/loading.3f2c979b.gif";